import React from "react";
import styles from "./index.module.scss";
import CallRecordsItem from "./call-records-item";
// import ItemHeader from "../item-header";
import { useCallRecordsListing } from "../../../../../../hooks/react-query/investor-dashboard/useCallRecordsListing";

export default function CallRecordsList({
  accountId,
  propertyId
}: {
  accountId: string;
  propertyId: string;
}) {
  const { data, isLoading } = useCallRecordsListing({
    acctId: accountId,
    pubPropertyId: propertyId
  });

  if (isLoading) {
    return (
      <div className={styles.timeline}>
        <div className={styles.loadingState}>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={styles.timeline}>
        <div className={styles.noDataState}>
          <span>No Call Records Found</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.timeline}>
      {data?.map((item: any, index: number) => (
        <div key={index} className={styles.timelineItem}>
          {/* <ItemHeader
            item={item}
            showActions={false}
            status={"Call-Recorded"}
          /> */}
          <CallRecordsItem item={item} />
        </div>
      ))}
    </div>
  );
}
